
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/harbor",
      function () {
        return require("private-next-pages/harbor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/harbor"])
      });
    }
  